import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { EmpMissingReportHdrContainer } from '../../../../../../models/aggregates/erp/financial';


@Injectable({
  providedIn: 'root'
})
export class EmpMissingReportHdrService extends BaseApiTemplateService<EmpMissingReportHdrContainer> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'emp-missing-report-hdr/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'emp-missing-report-hdr/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'emp-missing-report-hdr/backoffice-ep'
    this.httpClient = http;
  }

}
